import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe, SerializedPropertyMapPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { KeyValueBuilderComponentModule } from '@adaptiva/widgets/key-value-builder';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { CustomPropertiesComponent } from './custom-properties.component';

const WIDGETS: Type<any>[] = [
	CardComponentModule,
	ContainerComponentModule,
	TextComponentModule,
	InputComponentModule,
	ComboComponentModule,
	AuthoringPropertyLabelComponentModule,
	KeyValueBuilderComponentModule
];

const PIPES: Type<PipeTransform>[] = [
	DisplayAuthoringPropertyPipe,
	IsRequiredPropertyPipe,
	InheritPipe,
	SerializedPropertyMapPipe,
];

@NgModule({
	imports: [
		CommonModule,
		PIPES,
		WIDGETS
	],
	declarations: [CustomPropertiesComponent],
	exports: [CustomPropertiesComponent]
})
export class CustomPropertiesComponentModule {

}
